var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"or-filter-editor"},[_c('FilterListEditor',_vm._b({model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}},'FilterListEditor',_vm.subObjectBinds,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }